import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCredentials, setCredentials } from "../../authSlice";
import toast from "react-hot-toast";

function CustomerBalancesPrint() {
  const { token } = useSelector((state) => state.auth);
  const [allAreas, setAllAreas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedArea, setSelectedArea] = useState("");
   const [tokenExpired, setTokenExpired] = useState(false);
  const dispatch = useDispatch();

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const currentDate = getCurrentDate();

  useEffect(() => {
    const fetchAreas = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/getAllAreas`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 401) {
          setTokenExpired(true);
        }

        if (response.ok) {
          const newAccessToken = response.headers.get("Authorization");
          if (newAccessToken) {
            dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
          }
          const data = await response.json();
          setAllAreas(data || []);
        } else {
          throw new Error("Failed to fetch zimidars.");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    if (tokenExpired) {
      dispatch(clearCredentials());
      return
    }
    if (token) fetchAreas();
    if (!token || token === "null") {
      dispatch(setCredentials({ token: null, username: null }));
    }
  }, [dispatch, token,tokenExpired]);

  const exportReport = async () => {
    if (!selectedArea) return;
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/sales/customerbalanceandsalesexportcolleectionssheet?area=${selectedArea}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 401) {
        setTokenExpired(true)
        return
      }

      if (response.ok) {
        const newAccessToken = response.headers.get("Authorization");
        if (newAccessToken) {
          dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
        }
        const blob = await response.blob();
        // Create a download URL for the blob
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `Customer Balances and Sales [${selectedArea}].pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
        toast.message("File Exported successfully", {
          style: {
            border: "1px solid #021F7E",
            padding: "16px",
            color: "#0573E3",
          },
          iconTheme: {
            primary: "#021F7E",
            secondary: "#0573E3",
          },
        });
      } else {
        const data = await response.json();
        toast.error(data.message, {
          style: {
            border: "1px solid #FE0000",
            padding: "16px",
            color: "#FE0000",
          },
          iconTheme: {
            primary: "#FE0000",
            secondary: "#FE000099",
          },
        });
        throw new Error("Failed to export report.", data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="whiteBgDiv UserManagementPadding">
        <div className="mainHeading">
          Customer Balances and Sales [{currentDate}]
        </div>
        <div className="formHeading UserManagementpage">
          Export Collection Sheet
        </div>
        <div className="d-flex align-items-end flex-wrap gap-3">
          <div className="formInputLabelBox" style={{ flex: "1" }}>
            <label>Area</label>
            <select
              name="area"
              className="form-select"
              style={{ padding: "10.5px 21px" }}
              value={selectedArea}
              onChange={(e) => setSelectedArea(e.target.value)}
            >
              <option value="">Select area</option>
              {allAreas &&
                allAreas.map((area) => (
                  <option key={area._id} value={area.name}>
                    {area.name}
                  </option>
                ))}
            </select>
          </div>
          {loading ? (
            <button className="grayBtn">Loading...</button>
          ) : (
            <button className="colorBtn" onClick={exportReport}>
              Print
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default CustomerBalancesPrint;
